import{browserFeatures as t}from"../utils/supports.js";function e(e){return t.supports.flexGap?e:class extends e{connectedCallback(){super.connectedCallback(),this.setAttribute("_nfg","")}}}export{e as applyCSSGapShim};
